import { IElmServiceTaskMetadataUpdate } from '../../interfaces/employee-lifecycle/elm-service-task-metadata-update.interface';
import { ElmServiceTaskStatus } from '../../interfaces/employee-lifecycle/elm-service-task-status.enum';
import { IPaginationProps } from '../../interfaces/IPaginationProps';

export class LoadElmServiceTaskBoard {
  public static readonly type = '[ElmServiceTask] Load board';

  public constructor(
    public readonly paginationProps: IPaginationProps,
    public readonly assignedToMe: boolean,
    public readonly includeCompleted = false,
    public readonly requestVersion = 0,
    public readonly reset = true,
  ) {}
}

export class LoadElmServiceTaskStatusCounts {
  public static readonly type = '[ElmServiceTask] Load status counts';

  public constructor(
    public readonly paginationProps: IPaginationProps,
    public readonly assignedToMe: boolean,
    public readonly includeCompleted = false,
    public readonly requestVersion = 0,
  ) {}
}

export class LoadElmServiceTaskFilterValues {
  public static readonly type = '[ElmServiceTask] Load filter values';
}

export class LoadElmServiceTask {
  public static readonly type = '[ElmServiceTask] Load detail';

  public constructor(public readonly taskId: number) {}
}

export class ClearElmServiceTask {
  public static readonly type = '[ElmServiceTask] Clear detail';
}

export class ConsumeElmServiceTaskUpdate {
  public static readonly type = '[ElmServiceTask] Consume update';
}

export class ClaimElmServiceTask {
  public static readonly type = '[ElmServiceTask] Claim';

  public constructor(public readonly taskId: number) {}
}

export class UnclaimElmServiceTask {
  public static readonly type = '[ElmServiceTask] Unclaim';

  public constructor(public readonly taskId: number) {}
}

export class AssignElmServiceTask {
  public static readonly type = '[ElmServiceTask] Assign';

  public constructor(
    public readonly taskId: number,
    public readonly assignedToId: number,
  ) {}
}

export class UpdateElmServiceTaskMetadata {
  public static readonly type = '[ElmServiceTask] Update metadata';

  public constructor(
    public readonly taskId: number,
    public readonly payload: IElmServiceTaskMetadataUpdate,
  ) {}
}

export class UpdateElmServiceTaskNote {
  public static readonly type = '[ElmServiceTask] Update note';

  public constructor(
    public readonly taskId: number,
    public readonly serviceWorkerNote: string | null,
  ) {}
}

export class UpdateElmServiceTaskStatus {
  public static readonly type = '[ElmServiceTask] Update status';

  public constructor(
    public readonly taskId: number,
    public readonly status: ElmServiceTaskStatus,
    public readonly serviceWorkerNote?: string | null,
  ) {}
}
